import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { Log } from "ng2-logger";
import { Equipment } from "@models/equipment.model";

@Component({
    selector: 'app-tool-secondary-equipment-form',
    templateUrl: './tool-secondary-equipment-form.component.html',
    styleUrls: ['./tool-secondary-equipment-form.component.scss']
})
export class ToolSecondaryEquipmentFormComponent implements OnInit, OnChanges {
    _logger = Log.create(ToolSecondaryEquipmentFormComponent.name);

    @Input() selectedSecondaryEquipments: Equipment[];
    @Input() availableSecondaryEquipments: Equipment[];
    @Input() showValidations = false;


    form: UntypedFormGroup;


    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedSecondaryEquipments'] && this.form) {
            this.loadFormValues(this.selectedSecondaryEquipments);
        }
    }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.form = new UntypedFormGroup({
            selectedSecondaryEquipments: new UntypedFormControl(this.selectedSecondaryEquipments),
        });
    }

    loadFormValues(selectedSecondaryEquipments: Equipment[]) {
        this.form.setValue({
            selectedSecondaryEquipments: selectedSecondaryEquipments
        })
    }


    resetForm() {
        this._logger.info("resetForm:: with", this.availableSecondaryEquipments);
        this.showValidations = false;
        this.form.reset();
    }

    getFormValue() {
        return this.form.value;
    }

    get isFormValid() {
        this.showValidations = true;
        return this.form.valid;
    }
}
